import { render } from "./index.vue?vue&type=template&id=6a6ddcdc&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=6a6ddcdc&lang=less&scoped=true"
import "./index.vue?vue&type=style&index=1&id=6a6ddcdc&lang=less"

import exportComponent from "D:\\work\\mvgx-carbon-space-admin-site\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a6ddcdc"]])

export default __exports__